import { gql } from '@apollo/client';

export const GET_LOGIN_META = gql`
  query GetLoginMeta($email: String!) {
    loginMeta(email: $email) @client {
      email
      unlockTime
    }
  }
`;
